import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { ListingApiModel, ResponseApiModel } from '../../../../core/models/general.models';
import { FPXBusinessTypeEnum } from '../components/topup-popup/constants/topup-popup.constant';
import {
    BanksListDropdownApiModel,
    FpxReloadPaymentApiModel,
    TopupFormModel,
} from '../components/topup-popup/models/topup.model';
import { WithdrawFormModel } from '../components/withdraw-popup/models/withdraw.model';
import { WalletApiModel } from '../models/wallet.model';

@Injectable({
    providedIn: 'root',
})
export class WalletService {
    private readonly route = `${environment.apiHost}/api/v1/wallets`;
    private readonly routeV2 = `${environment.apiHost}/api/v2/wallets`;

    constructor(private httpClient: HttpClient) {}

    getWalletDetails(): Observable<WalletApiModel> {
        return this.httpClient.get<ResponseApiModel<WalletApiModel>>(this.route).pipe(
            map((response) => {
                return response.result;
            }),
        );
    }

    getWalletDetailsV2(): Observable<WalletApiModel[]> {
        return this.httpClient.get<ResponseApiModel<WalletApiModel[]>>(this.routeV2).pipe(
            map((response) => {
                return response.result;
            }),
        );
    }

    topupWallet(data: TopupFormModel): Observable<boolean> {
        const body = {
            amount: data.amount,
            attachmentId: data.attachmentId,
            // TODO: Check with PMO for UI OR API change
            recipientReference: '',
            transactionDate: '',
            walletType: data.walletType,
        };

        return this.httpClient.post<ResponseApiModel<boolean>>(`${this.routeV2}/reload/offline`, body).pipe(
            map((response) => {
                return response.result;
            }),
        );
    }

    submitWithdraw(data: WithdrawFormModel): Observable<boolean> {
        const body = {
            bankDetailId: data.bankDetailId,
            withdrawalAmount: data.withdrawalAmount,
            walletType: data.walletType,
        };

        return this.httpClient.post<ResponseApiModel<boolean>>(`${this.routeV2}/withdraw`, body).pipe(
            map((response) => {
                return response.result;
            }),
        );
    }

    getBanksListDropdown(model: FPXBusinessTypeEnum): Observable<BanksListDropdownApiModel[]> {
        const params = {
            businessModel: model,
        };

        return this.httpClient
            .get<ResponseApiModel<ListingApiModel<BanksListDropdownApiModel>>>(`${this.route}/reload/bank-list`, {
                params,
            })
            .pipe(
                map((response) => {
                    return response.result.data;
                }),
            );
    }

    submitFpxReloadPayment(data: TopupFormModel): Observable<FpxReloadPaymentApiModel> {
        const body = {
            businessModel: data.paymentMode,
            amount: data.amount,
            bankId: data.bank,
            walletType: data.walletType,
        };

        return this.httpClient
            .post<ResponseApiModel<FpxReloadPaymentApiModel>>(`${this.routeV2}/reload/online`, body)
            .pipe(
                map((response) => {
                    return response.result;
                }),
            );
    }
}
